import { render } from "./InspectionItemCheckList.vue?vue&type=template&id=2527054e"
import script from "./InspectionItemCheckList.vue?vue&type=script&lang=js"
export * from "./InspectionItemCheckList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__